import { EventName } from '@lit/react';
import { BlocksChip } from 'blocks-nextjs/blocks-web-components/components/chip/chip';
import { BlocksChipRemoveEvent, BlocksChipSelectEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatChip = createComponent({
  react: React,
  tagName: 'cat-chip',
  elementClass: BlocksChip,
  events: {
    onBlChipRemove: 'bl-chip-remove' as EventName<BlocksChipRemoveEvent>,
    onBlChipSelect: 'bl-chip-select' as EventName<BlocksChipSelectEvent>
  }
});
